import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-35db18cc"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  style: {"position":"relative"}
}
const _hoisted_2 = { class: "alert-notification-inside" }

import { onMounted, onUnmounted, ref } from 'vue'
import FriendshipService from '@/services/FriendshipService'
import { useAuth } from '@/store/useAuth'


export default /*#__PURE__*/_defineComponent({
  __name: 'ConversationNotification',
  props: ['friendId'],
  setup(__props) {

const props = __props
const service = new FriendshipService()
const unread = ref(0)
const store = useAuth()
const intervalId = window.setInterval(async () => {
    if(!store.token) {
        return
    }
    unread.value = await service.getUnreadMessagesSentByYourFriend(store.token, props.friendId)
}, 5000)

onMounted(async () => {
    if(!store.token) { return }
    unread.value = await service.getUnreadMessagesSentByYourFriend(store.token, props.friendId)
})

onUnmounted(() => {
    clearInterval(intervalId);
})

return (_ctx: any,_cache: any) => {
  return (unread.value > 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(unread.value), 1)
      ]))
    : _createCommentVNode("", true)
}
}

})